import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMilling = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.56412 0.000976562C1.10849 0.000976562 0 1.10945 0 2.56508C0 2.9017 0.0420705 3.22435 0.162342 3.53705C0.283467 3.85196 0.473797 4.13059 0.736203 4.393L8.55128 12.2081V23.501C8.55128 23.7021 8.67174 23.8836 8.85702 23.9617C9.0423 24.0398 9.25636 23.9994 9.40033 23.859L15.2978 18.109C15.3943 18.0149 15.4487 17.8858 15.4487 17.751V12.2081L23.2638 4.393C23.5262 4.13059 23.7165 3.85196 23.8377 3.53705C23.9579 3.22435 24 2.9017 24 2.56508C24 1.10945 22.8915 0.000976562 21.4359 0.000976562H2.56412Z",
		fill: "#C6CDD2"
	})
});
export default SvgMilling;
